import React from 'react';

import classNames from 'classnames';

import styles from './Message.module.css';
import { Icon, Icons } from '../icon/Icon';

export type MessageProps = {
  message: string;
  type?: 'error' | 'success' | 'benefit';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  icon?: (typeof Icons)[number];
};

export const Message = ({
  message,
  type = 'benefit',
  size = 'small',
  icon,
  className,
}: MessageProps) => {
  switch (type) {
    case 'error':
      icon = 'exclamationTriangleOutline';
      break;
    case 'success':
      icon = 'checkDefault';
      break;
    default:
      icon = 'checkCircleOutline';
  }

  return (
    <div
      className={classNames(
        styles.message,
        {
          [styles.error]: type === 'error',
          [styles.success]: type === 'success',
          [styles.small]: size === 'small',
          [styles.medium]: size === 'medium',
          [styles.large]: size === 'large',
        },
        className,
      )}
    >
      <Icon className={styles.icon} icon={icon} />
      <p className={styles.message}>{message}</p>
    </div>
  );
};
